const resources = {
    pageTitle: 'Sign In',
    // SIM-2 / ACS-4126 — credential-entry screen
    credentialLabel: 'Phone or Email Address',
    credentialPlaceholder: '(123) 456-7890',
    subtitlePrefix: 'Sign in or create an account to enjoy ',
    subtitleBold: 'FREE standard shipping',
    subtitleSuffix: ' on all orders.',
    newToSephora: 'New to Sephora?',
    continueButton: 'Continue',
    createAccountButton: 'Create Account',
    // ACS-4362 (VQA, Figma 288-97648): invalid-format is the typical input-field error
    // shown BELOW the field via TextInput's native invalid state.
    invalidCredential: 'Please enter a valid phone number or email.',
    // ACS-4362 (VQA, Figma 1308-116056 / 1308-116152): not-found is the typical
    // input-field error (below the field, no inline link). Backend errorMessage is
    // shown when present; this is the client fallback (matches the Figma copy).
    notFound: 'No account found. Please try again or create an account.',
    // ACS-4362 (VQA, Figma 753-95460): closed/deactivated account (ERR_ACCOUNT_CLOSED)
    // reactivate copy ABOVE the field as plain text. Backend errorMessage is shown when
    // present (e.g. "...Or Chat with our agents."); this is the client fallback.
    reactivateAccount: 'To reactivate the account, please call our Customer Service team at 1-877-SEPHORA (1-877-737-4672).',
    // ACS-4362 (VQA, Figma 1232-1309428): security-locked account (ERR_ACCOUNT_SYS_LOGIN)
    // ABOVE the field. "Reset your Password" is an inline link to /reset-password, so the
    // copy is split into prefix + link phrase + suffix (the backend errorMessage can't
    // carry the link and is not rendered verbatim for this state).
    lockedAccountPrefix: 'We have locked your account due to security concerns. Click here to ',
    lockedAccountResetLink: 'Reset your Password',
    lockedAccountSuffix: '.',
    closedAccount: 'This account has been closed. Contact customer service for assistance.',
    blockedAccount: 'Your account requires attention. Contact customer service to restore access.',
    // ERR_400004 - store-registered user with incomplete registration; backend
    // triggers a verification email (same flow as reset-password).
    storeRegistered:
        'Your account needs to be verified. We\'ve sent a verification email - please check your inbox to continue.',
    genericError: 'Something went wrong. Please try again in a few moments.',
    // SIM-10 / ACS-4134 — cross-cutting states.
    // AC-028 session timeout during the sign-in flow (redirect to /signin, cleared state).
    sessionExpired: 'Your session has expired. Please try again.',
    // BR-026/AC-026 — shown when a submit exceeds the 10s timeout.
    timeoutMessage: 'This is taking longer than expected. Please try again.',
    // Accessible label for the in-flight circular loader (Figma 270-85083).
    loadingLabel: 'Loading',
    // SIM-7 / ACS-4131 — OTP-first authorization + OTP entry, Figma node 270-84177
    // (radio group + single "Send" button; BR-034: always "verification code",
    // never "passcode").
    editLabel: 'Edit',
    // aria-label for the Edit affordance (AC-AUTH-EDIT / AC-AUTH-BACK: Edit is the
    // return-to-credential path in this frame — no separate back chevron).
    editAriaLabel: 'Edit email or phone number',
    // Radiogroup accessible name. Carries the BR-034 "verification code"
    // terminology; option labels also use it (Figma copy).
    authorizationSubtitle: 'How would you like to receive your verification code?',
    // Radio-option labels (BR-007 order: SMS, Email, Password) — Figma 270-84177.
    // The SMS label carries "verification code" (BR-034).
    smsMethodLabel: 'Text me a verification code',
    emailMethodLabel: 'Email me a verification code',
    passwordMethodLabel: 'Enter password',
    // SMS-consent copy under the SMS option only (BR-033 / AC-AUTH-SMSCONSENT).
    // The TEXT TERMS + PRIVACY POLICY anchors are rendered as real, UPPERCASED
    // links by the screen (Figma 270-84177).
    smsConsentPrefix:
        'The information collected here will only be used for verification purposes. Message and data rates may apply. By clicking "Send", you (1) agree to the current version of our ',
    smsConsentTextTerms: 'Text Terms',
    smsConsentMiddle: ', and (2) have read Sephora\'s ',
    smsConsentPrivacy: 'Privacy Policy',
    smsConsentSuffix: '.',
    // Single commit button for the selected method (Figma: always "Send").
    sendButton: 'Send',
    // OTP entry (Phase 3) — Figma node 270-84837 (phone) / 181-169990 (email).
    // Accessible group name for the 6-box code entry (kept for OTP-03 a11y).
    otpInputAriaLabel: 'Enter 6-digit verification code',
    // Per-box accessible name for the shared components/OtpInputGroup — {0} is the
    // 1-based box index, interpolated by OtpInputGroup via stringUtils.format.
    otpInputBoxAriaLabel: 'Verification code input {0}',
    // Section label + heading switch on sms-vs-email (BR-034: "verification code").
    otpSectionLabelPhone: 'Phone Verification',
    otpSectionLabelEmail: 'Email Verification',
    otpHeadingPhone: 'Check your messages and enter your verification code',
    otpHeadingEmail: 'Check your email and enter your verification code',
    // Subtitle: "You will receive a code at {maskedDestination} if it is
    // registered with a Beauty Insider account." — the masked destination is bold
    // inline and interpolated by the screen (BR-021: never the raw value).
    otpSubtitlePrefix: 'You will receive a code at ',
    otpSubtitleSuffix: ' if it is registered with a Beauty Insider account.',
    // Resend line: "Didn't get {channel}? Resend code in {N} seconds" — the channel
    // + countdown switch on mode; the "Resend code" portion becomes a link once the
    // cooldown elapses.
    resendPrefix: 'Didn\'t get ',
    resendChannelPhone: 'the SMS',
    resendChannelEmail: 'an email',
    resendQuestion: '? ',
    resendButton: 'Resend code',
    // Countdown template — the seconds count is interpolated by the screen.
    resendCountdownPrefix: 'Resend code in ',
    resendCountdownSuffix: ' seconds',
    // White pill with a 2px black border; navigates back to the method-choice
    // (authorization) screen (SIM-7 scope).
    tryAnotherMethodButton: 'Try Another Method',
    // AC-036: identical copy for expired AND incorrect (no leakage, BR-029). The
    // masked destination is appended by the screen.
    otpExpiredOrIncorrect: 'That code has expired or is incorrect. We sent a new verification code to ',
    // Send-failure copy (SEND-04).
    otpSendFailed: 'We couldn\'t send your verification code. Try a different method.',
    // BR-025 resend limit reached.
    otpLimitMessage: 'Too many attempts. Try a different sign-in method or contact customer service.',
    // SIM-8 / ACS-4132 — password-fallback screen (BR-011: NO lockout copy anywhere;
    // BR-034: "verification code", never "passcode" / "one-time code").
    passwordLabel: 'Password',
    signInButton: 'Sign In',
    // AC-020 verbatim wrong-password copy — MUST NOT be paraphrased. Carries the
    // BR-034 "verification code" terminology.
    wrongPasswordError:
        'The password you entered is incorrect. Try again or sign in with a one-time verification code.',
    // Empty-password inline validation — shown when "Sign In" is clicked with a blank
    // password field (guards against an empty-input login attempt).
    passwordRequired: 'Please enter your password.',
    // "Forgot password?" affordance beneath the password field (AC-009 borrowed).
    forgotPassword: 'Forgot password?',
    // "By clicking Sign In..." Terms/Privacy legal copy shown above the primary
    // button when the password option is selected (Figma 270-87274). Uses the
    // SAME SMS_CONSENT_TEXT_TERMS_URL / SMS_CONSENT_PRIVACY_URL constants below
    // (single source of truth for the two legal destinations).
    signInLegalPrefix: 'By clicking "Sign In", you (1) agree to the current version of our ',
    signInLegalMiddle: ', and (2) have read Sephora\'s ',
    signInLegalSuffix: '.',
    // Password-mode legal anchor label (Figma 283-92324 renders "TERMS OF USE";
    // uppercased by the screen's consentLink style). Links to TERMS_OF_USE_LINK —
    // distinct from the SMS-consent "Text Terms" (TEXT_TERM_LINK) block.
    termsOfUse: 'Terms of Use',
    // SIM-9 / ACS-4133 - phone-disambiguation email-confirmation mode (Figma 1466-19076).
    // Generic prompt (no account-count leak, BR-002/003).
    emailConfirmSubtitle: 'Enter your email address associated with your account.',
    emailConfirmLabel: 'Email Address',
    // SIM-8 / ACS-4132 — forced-challenge step-up alt-channel affordance (Figma
    // 2271-60328). Shown on the PHONE step-up OTP screen only: a black prefix +
    // a blue Link that swaps the OTP delivery from SMS to email. BR-034 requires
    // "verification code", never "passcode" — the Figma "Send passcode via email"
    // string is normalized to the compliant wording here.
    noAccessToPhonePrefix: 'No Access to this phone? ',
    sendCodeViaEmail: 'Send verification code via email'
};

export default function getResource(label) {
    return resources[label];
}
